import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import App from './Components/App/App.jsx';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);